import React from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { canMaintainCharitySetup } from "../../../../../../utils/onboarding/onboardingAccess";

interface Props {
  children: React.ReactElement;
  isSuperadmin: boolean;
}

const MaintainAccessGateInner: React.FC<Props> = ({
  children,
  isSuperadmin,
}) => {
  if (!canMaintainCharitySetup({ isSuperadmin })) {
    return <Navigate to="/contacts" replace />;
  }
  return children;
};

const mapStateToProps = (state: any) => ({
  isSuperadmin: Boolean(state.user?.isSuperadmin),
});

export default connect(mapStateToProps)(MaintainAccessGateInner);
